module.exports = __webpack_public_path__ + "static/media/plus-icon.a96dc943.svg";